import React from 'react';
import Slider from 'react-slick';
import Footer from './Footer';
import mh1 from './img/mahacal1.jpg';
import mh2 from './img/mahacal2.jpg';
import mh3 from './img/mahacal3.jpg';
import mh4 from './img/mahacal4.jpg';

import google from '../component/img/goole.jpg'

// Import slick-carousel CSS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Custom arrow components
const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick} style={{ ...arrowStyles, right: '10px' }}>
            <i className="fa fa-chevron-right" aria-hidden="true"></i>
        </div>
    );
};

const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick} style={{ ...arrowStyles, left: '10px' }}>
            <i className="fa fa-chevron-left" aria-hidden="true"></i>
        </div>
    );
};

// Styles for the arrows
const arrowStyles = {
    position: 'absolute',
    top: '50%',
    zIndex: 1,
    fontSize: '24px',
    color: '#000',
    cursor: 'pointer',
    transform: 'translateY(-50%)',
    background: 'rgba(255, 255, 255, 0.7)', // Optional background for visibility
    borderRadius: '50%',
    padding: '10px',
};

const Mahacal = () => {
    // Settings for the slider
    const settings = {
        dots: true, // Display navigation dots
        infinite: true, // Infinite scrolling
        speed: 500, // Transition speed
        slidesToShow: 4, // Number of slides to show at once
        slidesToScroll: 1, // Number of slides to scroll at once
        arrows: true, // Show left/right arrows
        nextArrow: <SampleNextArrow />, // Custom next arrow
        prevArrow: <SamplePrevArrow />, // Custom prev arrow
        responsive: [
            {
                breakpoint: 1024, // Tablet breakpoint
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768, // Mobile breakpoint
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480, // Extra small mobile breakpoint
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div>
            <Slider {...settings}>
                <div className='image-container'>
                    <img src={mh1} alt="Mahacal 1" />
                </div>
                <div className='image-container'>
                    <img src={mh2} alt="Mahacal 2" />
                </div>
                <div className='image-container'>
                    <img src={mh3} alt="Mahacal 3" />
                </div>
                <div className='image-container'>
                    <img src={mh4} alt="Mahacal 4" />
                </div>
            </Slider>


            <div className='mahacals'>
                <h2>Mahakaal  Packages From Lucknow</h2>
                <p><strong>Location:</strong> Lucknow, Gomtinagar</p>
                <p><strong>Price:</strong> ₹49,999.00</p>
                <p><strong>Duration:</strong> 4 days</p>
                <p><strong>Tour Type:</strong> Holiday Package (with stay) <br /> <br />  <span style={{ fontSize: '14px' }}> * T&C Apply</span></p>
            </div>


            <div className='packedges   '>

                <div className='newpacks'>

                    <h1>Mahakaal Packages From Lucknow</h1>

                    <p>Get the best deals on Mahakaal packages from Lucknow flat 20% off on your first booking.</p>

                    <p>Mahakaal, located in Ujjain, Madhya Pradesh, India, is a sacred and historic destination that draws countless devotees and travelers year-round. Home to the renowned Mahakaleshwar Jyotirlinga, one of the twelve Jyotirlingas of Lord Shiva, the temple holds immense spiritual significance. Beyond its religious appeal, Mahakaal offers a tranquil environment and rich cultural heritage, making it a must-visit for pilgrims and history enthusiasts alike.</p> <p>For travelers from Lucknow, reaching Mahakaal is a fulfilling spiritual journey. The distance between Lucknow and Ujjain is approximately 800 kilometers and can be covered via train, bus, or private vehicle. Trains offer a comfortable and economical option, while road travel allows you to enjoy scenic views along the route. Several travel agencies and platforms like Indiator also offer guided tours and travel assistance to ensure a smooth experience from Lucknow to Mahakaal.</p> <p>Whether you’re seeking spiritual awakening or simply want to explore the ancient charm of Ujjain, a trip from Lucknow to Mahakaal promises a blend of devotion, history, and cultural richness. Proper planning, including checking train schedules or booking reliable road transport, can make your journey both comfortable and memorable.</p>

                </div>



                <div className='newpacks googles'>

                    <div className="cards">
                        <h2>Tour Information</h2>
                        <p><strong>Max Guests:</strong> 60</p>
                        <p><strong>Min Age:</strong> 12</p>
                        <p><strong>Location:</strong> <span class="location">Mahakaal</span></p>
                        <p className="languages"><strong>Languages Supported:</strong> Hindi,English </p>

                    </div>



                    <div className='google'>
                        <img src={google} />
                        <button><a href='https://www.google.com/search?q=prism+travels+lucknow&oq=prism'> <i class="fa fa-google-plus"></i> Google Review</a></button>
                    </div>

                </div>


            </div>

            <Footer />

        </div>
    );
};

export default Mahacal;
